export const SEARCH_GET_HP_REQUEST = 'SEARCH_GET_HP_REQUEST';
export const SEARCH_GET_HP_SUCCESS = 'SEARCH_GET_HP_SUCCESS';
export const SEARCH_GET_HP_FAILURE = 'SEARCH_GET_HP_FAILURE';

export const SEARCH_RESET = 'SEARCH_RESET';
export const SEARCH_TEXT = 'SEARCH_TEXT';
